module.exports = __webpack_public_path__ + "img/upArrow.0607987a.svg";